import { BaseResponse } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 资源位状态枚举
 */
export enum ResourcePositionStatus {
  /** 上线 */
  Online = 0,
  /** 下线 */
  Offline = 1,
}

/**
 * 资源位详情接口
 */
export interface ResourcePosition {
  /** 资源位ID */
  code: string;
  /** 资源位位置描述 */
  codeName: string;
  /** 状态：0.上线 1.下线 */
  status: ResourcePositionStatus;
  /** 上线中的素材数 */
  count: number;
  /** 最近更新时间 */
  updateTime: string;
  /** 最近更新人 */
  updateUserName: string;
  /** 最近更新人Id */
  updateUserId: string;
}

/**
 * 分页查询参数接口
 */
export interface ResourcePositionPageParams {
  /** 当前页码 */
  currentPage: number;
  /** 每页大小 */
  pageSize: number;
  /** 状态筛选 */
  status?: ResourcePositionStatus;
}

/**
 * 分页查询响应接口
 */
export interface ResourcePositionPageResponse {
  /** 总记录数 */
  total: number;
  /** 当前页 */
  currentPage: number;
  /** 每页大小 */
  pageSize: number;
  /** 记录列表 */
  records: ResourcePosition[];
}

/**
 * 获取资源位分页列表
 * @param params 查询参数
 */
export const getResourcePositionPageList = async (params: ResourcePositionPageParams) => {
  const resp = await axiosInstance.post<BaseResponse<ResourcePositionPageResponse>>(
    `${baseUrl}/resource/position/queryPageList`,
    params
  );
  return resp.data;
};

/**
 * 资源位上架
 * @param code 资源位编码
 */
export const upResourcePosition = async (code: string) => {
  const resp = await axiosInstance.put<BaseResponse<void>>(
    `${baseUrl}/resource/position/up/${code}`
  );
  return resp.data;
};

/**
 * 资源位下架
 * @param code 资源位编码
 */
export const downResourcePosition = async (code: string) => {
  const resp = await axiosInstance.put<BaseResponse<void>>(
    `${baseUrl}/resource/position/down/${code}`
  );
  return resp.data;
};
